// extracted by mini-css-extract-plugin
module.exports = {"movie":"movies_movie__30syE","image":"movies_image__2WN6Y"};